import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useEffect, useState} from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import requestLogColumns from "./RequestLogColumns";
import {useTranslation} from "react-i18next";
import JsonViewModal from "../../../core/components/JsonViewModal";

export default function RequestLogGrid()
{
    const {t} = useTranslation();
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();
    const [jsonModalVisible, setJsonModalVisible] = useState(false);
    const [selectedJson, setSelectedJson] = useState(null);

    const handleViewJson = (data) => {
        setSelectedJson(data);
        setJsonModalVisible(true);
    };

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: requestLogColumns(t, handleViewJson),
        })
    }, [])

    const getRequestLogGrid = async () => {
        const response = await ApiService.Log.GetRequestLogDataGrid(queryModel);
        if(response.success)
        {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    useEffect(() => {
        getRequestLogGrid()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid name={'request-log'}/>
            <JsonViewModal 
                visible={jsonModalVisible} 
                data={selectedJson} 
                onClose={() => setJsonModalVisible(false)}
                title={t('Request Body')}
            />
        </>
    )
}
